import { VALUES } from "../lib/data";

export default function WhyUs() {
  return (
    <section
      id="why"
      data-testid="why-section"
      className="relative py-24 md:py-32 overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid lg:grid-cols-12 gap-12 items-start">
          <div className="lg:col-span-5 lg:sticky lg:top-32">
            <div className="eyebrow mb-5">— The Barks &amp; Co Way</div>
            <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl text-brown-dark leading-[1.05] tracking-tight">
              Why dogs (and their humans) <em className="italic text-lilac-dark">love it here</em>.
            </h2>
            <p className="mt-6 text-lg text-text-secondary max-w-md">
              A few quiet promises that shape every appointment.
            </p>
          </div>

          <div className="lg:col-span-7 grid sm:grid-cols-2 gap-6">
            {VALUES.map((v, i) => (
              <div
                key={v.title}
                data-testid={`value-card-${i}`}
                className="relative p-8 rounded-[2rem] bg-cream border border-[#E6DEC3] hover:border-lilac transition-all duration-500 group"
              >
                <div className="flex items-center gap-3 mb-4">
                  <span className="font-serif italic text-3xl text-lilac-dark">
                    0{i + 1}
                  </span>
                  <div className="h-px flex-1 bg-[#E6DEC3] group-hover:bg-lilac-dark transition-colors duration-500" />
                </div>
                <h3 className="font-serif text-2xl text-brown-dark mb-3">
                  {v.title}
                </h3>
                <p className="text-text-secondary leading-relaxed">{v.text}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
